/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Mail_Compose_FailedInputs */

const en_mail_compose_failed = /** @type {(inputs: Mail_Compose_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`, ${i?.count} failed`)
};

const de_mail_compose_failed = /** @type {(inputs: Mail_Compose_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`, ${i?.count} fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | ", {count} failed" |
*
* @param {Mail_Compose_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_failed = /** @type {((inputs: Mail_Compose_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_failed(inputs)
	return en_mail_compose_failed(inputs)
});